var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePodcasts = function SvgGooglePodcasts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-podcasts_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.227 12.702c1.23 0 2.226.997 2.226 2.227v2.143a2.227 2.227 0 1 1-4.453 0V14.93c0-1.23.997-2.227 2.227-2.227Z",
    fill: "#0066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.773 12.702c1.23 0 2.227.997 2.227 2.227v2.143a2.227 2.227 0 1 1-4.453 0V14.93c0-1.23.997-2.227 2.226-2.227Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.113 6.271c1.23 0 2.227.997 2.227 2.227v7.011a2.227 2.227 0 0 1-4.453 0V8.5c0-1.23.997-2.228 2.226-2.228Zm0 12.862c1.23 0 2.227.997 2.227 2.227v2.143a2.227 2.227 0 1 1-4.453 0V21.36c0-1.23.997-2.227 2.226-2.227Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.887 6.27c1.23 0 2.226.998 2.226 2.227v2.144a2.227 2.227 0 1 1-4.453 0V8.497c0-1.23.997-2.226 2.227-2.226Zm0 7.995c1.23 0 2.226.997 2.226 2.226v7.012a2.227 2.227 0 0 1-4.453 0V16.49c0-1.23.997-2.226 2.227-2.226Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0c1.23 0 2.227.997 2.227 2.227V4.37a2.227 2.227 0 1 1-4.454 0V2.227C13.773.997 14.77 0 16 0Zm0 8.058c1.23 0 2.227.996 2.227 2.226v11.432a2.227 2.227 0 1 1-4.454 0V10.284c0-1.23.997-2.226 2.227-2.226Zm0 17.345c1.23 0 2.227.997 2.227 2.227v2.143a2.227 2.227 0 0 1-4.454 0V27.63c0-1.23.997-2.227 2.227-2.227Z",
    fill: "#FAB908"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-podcasts_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgGooglePodcasts;